// Mock data for Sikka IT Solutions

export const trainingPrograms = [
  {
    id: 1,
    title: "Web Development",
    description: "Master modern web technologies including HTML5, CSS3, JavaScript, React, and Node.js. Build responsive, scalable web applications.",
    duration: "12 weeks",
    level: "Beginner to Advanced",
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800",
    features: ["Hands-on Projects", "Live Sessions", "Industry Mentors", "Certification"]
  },
  {
    id: 2,
    title: "App Development",
    description: "Learn to build native and cross-platform mobile applications using React Native, Flutter, and modern development practices.",
    duration: "10 weeks",
    level: "Intermediate",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800",
    features: ["Real Apps", "Play Store Deployment", "UI/UX Best Practices", "Certification"]
  },
  {
    id: 3,
    title: "Networking",
    description: "Comprehensive networking course covering TCP/IP, routing, switching, security, and cloud networking fundamentals.",
    duration: "8 weeks",
    level: "Beginner to Intermediate",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800",
    features: ["Lab Simulations", "Cisco & CompTIA Prep", "Real-world Scenarios", "Certification"]
  },
  {
    id: 4,
    title: "AI Automation",
    description: "Explore artificial intelligence, machine learning, and automation tools to streamline business processes and workflows.",
    duration: "14 weeks",
    level: "Advanced",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800",
    features: ["AI Models", "Automation Tools", "Python & TensorFlow", "Certification"]
  },
  {
    id: 5,
    title: "Data Analysis",
    description: "Learn data visualization, statistical analysis, SQL, Python, and business intelligence tools to make data-driven decisions.",
    duration: "10 weeks",
    level: "Beginner to Advanced",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800",
    features: ["Excel & SQL", "Python & Pandas", "Power BI/Tableau", "Certification"]
  }
];

export const customSoftwareServices = [
  {
    id: 1,
    title: "Custom Web Applications",
    description: "Tailored web solutions built with cutting-edge technologies to meet your unique business requirements.",
    icon: "Globe",
    technologies: ["React", "Node.js", "Python/Django", "MongoDB", "PostgreSQL"]
  },
  {
    id: 2,
    title: "Mobile App Development",
    description: "Native and cross-platform mobile applications designed for optimal performance and user experience.",
    icon: "Smartphone",
    technologies: ["React Native", "Flutter", "iOS/Swift", "Android/Kotlin", "Firebase"]
  },
  {
    id: 3,
    title: "Enterprise Software",
    description: "Scalable enterprise solutions including CRM, ERP, and custom business management systems.",
    icon: "Building2",
    technologies: ["Java/Spring", ".NET Core", "Microservices", "Azure", "AWS"]
  },
  {
    id: 4,
    title: "API Development & Integration",
    description: "Robust API development and seamless third-party integrations to connect your systems.",
    icon: "Link",
    technologies: ["REST APIs", "GraphQL", "OAuth", "Payment Gateways", "Third-party APIs"]
  },
  {
    id: 5,
    title: "Cloud Solutions",
    description: "Cloud migration, deployment, and management services for AWS, Azure, and Google Cloud.",
    icon: "Cloud",
    technologies: ["AWS", "Azure", "Google Cloud", "Docker", "Kubernetes"]
  },
  {
    id: 6,
    title: "Maintenance & Support",
    description: "Ongoing maintenance, updates, and technical support to keep your software running smoothly.",
    icon: "Wrench",
    technologies: ["24/7 Support", "Bug Fixes", "Performance Optimization", "Security Updates", "Monitoring"]
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "E-Commerce Platform",
    client: "RetailCo Inc.",
    description: "Built a comprehensive e-commerce platform with payment gateway integration, inventory management, and analytics dashboard.",
    image: "https://images.unsplash.com/photo-1557821552-17105176677c?w=800",
    technologies: ["React", "Node.js", "MongoDB", "Stripe"],
    category: "Web Application"
  },
  {
    id: 2,
    title: "Healthcare Management System",
    client: "MediCare Solutions",
    description: "Developed a HIPAA-compliant patient management system with appointment scheduling and telemedicine features.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800",
    technologies: ["React Native", "Python", "PostgreSQL", "AWS"],
    category: "Mobile App"
  },
  {
    id: 3,
    title: "Supply Chain Analytics",
    client: "LogisticsPro",
    description: "Created a data analytics platform for real-time supply chain monitoring and predictive analytics.",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800",
    technologies: ["Python", "Power BI", "Azure", "Machine Learning"],
    category: "Data Analytics"
  },
  {
    id: 4,
    title: "Movie & Event Booking Platform",
    client: "Entertainment Hub",
    description: "Comprehensive booking system for movies and events with seat selection, payment integration, and digital ticket generation.",
    image: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=800",
    technologies: ["React", "Node.js", "MongoDB", "Razorpay"],
    category: "Web Application"
  },
  {
    id: 5,
    title: "Wedding Planner Website",
    client: "Dream Weddings Co.",
    description: "Full-service wedding planning platform with vendor management, budget tracking, guest list management, and timeline planning.",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800",
    technologies: ["React", "Firebase", "Node.js", "Stripe"],
    category: "Web Application"
  },
  {
    id: 6,
    title: "Sports Shop Inventory Management",
    client: "Sports Arena",
    description: "Complete inventory management system with real-time stock tracking, supplier management, sales analytics, and automated reordering.",
    image: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800",
    technologies: ["React", "Python", "PostgreSQL", "AWS"],
    category: "Inventory System"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Business Owner",
    company: "Sharma Enterprises, Lucknow",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400",
    rating: 5,
    text: "Sikka IT Solutions developed our company website and inventory system. The team was professional and delivered exactly what we needed. Highly recommended for businesses in Lucknow!"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    role: "Managing Director",
    company: "Kumar Industries",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
    rating: 5,
    text: "Outstanding service! They created our e-commerce platform with payment integration. The project was completed on time and within budget. Great experience working with them."
  },
  {
    id: 3,
    name: "Ananya Verma",
    role: "Founder",
    company: "Verma Coaching Classes",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400",
    rating: 5,
    text: "We got our coaching institute's website and student management system developed by Sikka IT Solutions. Very satisfied with their work. They understand local business needs very well."
  },
  {
    id: 4,
    name: "Amit Gupta",
    role: "CEO",
    company: "Gupta Textiles, Aminabad",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400",
    rating: 5,
    text: "Excellent team! They built our textile inventory management system and helped us digitize our business. The after-sales support is also very good. Definitely recommend them."
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Individual Course",
    price: "₹15,000",
    period: "per course",
    description: "Perfect for individual learners",
    features: [
      "Access to one training program",
      "Live interactive sessions",
      "Recorded lectures access",
      "Course completion certificate",
      "Basic support",
      "Community access"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Professional Bundle",
    price: "₹40,000",
    period: "3 courses",
    description: "Best value for career growth",
    features: [
      "Access to any 3 training programs",
      "Priority support",
      "1-on-1 mentorship sessions",
      "Resume building workshop",
      "Interview preparation",
      "Lifetime community access",
      "Job referral assistance"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Enterprise Training",
    price: "Custom",
    period: "contact us",
    description: "Tailored for organizations",
    features: [
      "Custom curriculum design",
      "On-site or remote training",
      "Dedicated account manager",
      "Progress tracking dashboard",
      "Flexible scheduling",
      "Post-training support",
      "Bulk discount available"
    ],
    popular: false
  }
];

export const softwarePricing = [
  {
    id: 1,
    name: "Starter Project",
    price: "₹10,000",
    period: "starting at",
    description: "Small-scale applications",
    features: [
      "Basic web/mobile application",
      "Up to 5 pages/screens",
      "Responsive design",
      "Basic features",
      "1 month support",
      "Source code delivery"
    ]
  },
  {
    id: 2,
    name: "Business Solution",
    price: "₹50,000",
    period: "starting at",
    description: "Medium to large projects",
    features: [
      "Complex web/mobile application",
      "Custom features & integrations",
      "Database design",
      "API development",
      "3 months support",
      "Training & documentation"
    ]
  },
  {
    id: 3,
    name: "Enterprise Solution",
    price: "Custom",
    period: "contact us",
    description: "Large-scale systems",
    features: [
      "Full-scale enterprise software",
      "Advanced integrations",
      "Scalable architecture",
      "Security & compliance",
      "12 months support",
      "Dedicated team"
    ]
  }
];

export const stats = [
  { label: "Work Experience in IT", value: "30+ Years", icon: "Award" },
  { label: "Projects Delivered", value: "100+", icon: "CheckCircle" },
  { label: "Industry Experts", value: "25+", icon: "Users" },
  { label: "Success Rate", value: "95%", icon: "TrendingUp" }
];

export const faqs = [
  {
    id: 1,
    question: "What is your software development process?",
    answer: "We follow an agile methodology with regular sprint reviews. Our process includes discovery, design, development, testing, deployment, and ongoing support. We ensure transparent communication throughout the project."
  },
  {
    id: 2,
    question: "How long does it take to develop custom software?",
    answer: "Timeline depends on project complexity. Starter projects typically take 1-2 weeks, while customized software solutions take 1-2 months. We provide detailed timelines during the initial consultation based on your specific requirements and chosen technologies."
  },
  {
    id: 3,
    question: "What technologies do you specialize in?",
    answer: "We work with modern tech stacks including React, Node.js, Python, Java, Flutter, React Native, AWS, Azure, MongoDB, PostgreSQL, and many more. We choose the best technology based on your project requirements, scalability needs, and budget."
  },
  {
    id: 4,
    question: "Do you provide post-project support and maintenance?",
    answer: "Yes, all our software projects include a support period ranging from 1 to 12 months depending on the package. We also offer extended maintenance contracts for ongoing support, updates, and feature enhancements."
  },
  {
    id: 5,
    question: "Can I see examples of your previous work?",
    answer: "Absolutely! Check out our Portfolio section to see recent projects including e-commerce platforms, booking systems, wedding planning websites, inventory management systems, and more. Each case study includes technologies used and project outcomes."
  },
  {
    id: 6,
    question: "What is included in the project cost?",
    answer: "Our pricing includes project planning, design, development, testing, deployment, and initial support period. We provide detailed cost breakdowns during consultation. Additional features, integrations, or extended support can be added as needed."
  },
  {
    id: 7,
    question: "Do you sign NDAs and protect intellectual property?",
    answer: "Yes, we take confidentiality seriously. We're happy to sign NDAs before discussing your project. All intellectual property rights are transferred to you upon project completion and final payment."
  },
  {
    id: 8,
    question: "Can you help with API integrations and third-party services?",
    answer: "Yes, we specialize in integrating payment gateways (Stripe, Razorpay), email services, SMS providers, cloud storage, analytics tools, and various other third-party APIs to enhance your application's functionality."
  }
];
